import { render } from "./AdminIncidentsManagement.vue?vue&type=template&id=2c5f7ded&scoped=true"
import script from "./AdminIncidentsManagement.vue?vue&type=script&lang=js"
export * from "./AdminIncidentsManagement.vue?vue&type=script&lang=js"

import "./AdminIncidentsManagement.vue?vue&type=style&index=0&id=2c5f7ded&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5f7ded"]])

export default __exports__